import { render } from "./VerificationView.vue?vue&type=template&id=1d4f2ce6&scoped=true"
import script from "./VerificationView.vue?vue&type=script&lang=js"
export * from "./VerificationView.vue?vue&type=script&lang=js"

import "./VerificationView.vue?vue&type=style&index=0&id=1d4f2ce6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f2ce6"]])

export default __exports__